<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-07-15 15:30:46
-->
<template>
  <Common>
    <template slot="cd">
      <Login />
    </template>
    <template slot="sz">
      <Login />
    </template>
    <template slot="hf">
      <Login />
    </template>
  </Common>
</template>

<script>
import Login from '@/components/hospitalLogin/login'
export default {
  components: {
    Login,
  },

  data() {
    return {}
  },
  created() {
   
  },
}
</script>
<style lang="less" scoped></style>
